<template>
  <v-app>
    <div
      style="position: fixed; top: 0; right: 0; opacity: 0.04"
      class="text-caption ma-1"
    >
      {{ version }}
    </div>
    <v-main class="background-image">
      <v-row no-gutters justify="center" v-if="ready">
        <v-col>
          <v-fade-transition hide-on-leave>
            <router-view />
          </v-fade-transition>
        </v-col>
      </v-row>
    </v-main>
    <div
      style="position: fixed; bottom: 0; z-index: 100; width: 100%"
      v-if="
        ready &&
        !$route.path.includes('/plant/') &&
        !$route.path.includes('/update') &&
        !$route.path.includes('/sign-in')
      "
    >
      <v-row no-gutters justify="center">
        <v-slide-group show-arrows center-active style="width: 100%">
          <v-row no-gutters justify="center">
            <div class="glassmorphism rounded-pill px-1 mb-2">
              <v-slide-item v-for="item in items" :key="item.to">
                <v-btn
                  class="mx-1 my-2 text-none elevation-2"
                  active-class="primary white--text "
                  large
                  style="background-color: white; transition: all 0.3s"
                  rounded
                  link
                  :to="item.to"
                >
                  {{ item.name }}
                </v-btn>
              </v-slide-item>
            </div>
          </v-row>
        </v-slide-group>
      </v-row>
    </div>
    <FullScreenPicture />
    <Snackbar />
  </v-app>
</template>

<script>
import FullScreenPicture from "./components/FullScreenPicture";
import Snackbar from "./components/Snackbar";
import { mapState } from "vuex";
import { version } from "../package.json";
const fb = require("./firebase.js");

export default {
  name: "App",
  data() {
    return { version: version, ready: false };
  },
  components: {
    FullScreenPicture,
    Snackbar,
  },
  created() {
    this.$router.onReady(() => {
      fb.firebase.auth().onAuthStateChanged((userMetaData) => {
        if (!userMetaData) {
          if (this.$route.name !== "SignIn") this.$router.push("/sign-in");
        } else if (userMetaData) {
          this.$store.dispatch("update/getVersion");
          this.$store.dispatch("self/getSelf", userMetaData.uid);
          if (this.$route.name == "SignIn") this.$router.push("/");
        }
        this.ready = true;
      });
    });
  },
  computed: {
    ...mapState("self", ["self", "selfPending"]),
    items() {
      return [
        {
          name: "My Garden",
          icon: "mdi-account",
          to: `/garden/${this.self.id}`,
        },
        { name: "Activity", icon: "mdi-account", to: "/" },
        { name: "Explore", icon: "mdi-account", to: "/explore/all" },
      ];
    },
  },
};
</script>
<style >
.main-font {
  font-family: mainFont;
}

@font-face {
  font-family: mainFont;
  src: url("/font/Vidaloka-Regular.ttf");
}
/* page transition */
.transition-page-enter-active {
  transition: all 0.5s;
}
.transition-page-enter {
  /* transform: translateY(-10px); */
  opacity: 1;
}

.v-slide-group__wrapper {
  padding-right: 0px !important;
}

.glassmorphism {
  background: rgba(255, 255, 255, 0.2);
  backdrop-filter: blur(9px);
  -webkit-backdrop-filter: blur(9px);
}
.background-image {
  background-image: url("/img/illustrations/background.svg");
  background-size: cover;
  background-position: center center;
  background-attachment: fixed;
}

::-webkit-scrollbar {
  width: 0px;
}
.add-scrollbar {
  overflow: auto;
}
.add-scrollbar::-webkit-scrollbar {
  width: 6px;
}
.add-scrollbar::-webkit-scrollbar-track {
  border-radius: 3px;
}
.add-scrollbar::-webkit-scrollbar-thumb {
  border-radius: 3px;
  background: rgba(194, 194, 194, 0.5);
}
</style>